/**
 * Pure helpers for the host's "Agrupar por IA" panel (US-LV-21). Kept out of the component because
 * this app has no jsdom: the decisions are tested here and the React shell is read by eye.
 */
export interface ResponseGroupView {
  label: string;
  entryIds: string[];
}

/** The i18n key for a failed grouping call. An unknown code falls back to the generic failure. */
export function groupErrorKey(status: number, code: string | undefined): string {
  if (code === "NOTHING_TO_GROUP" || code === "NOT_AN_OPEN_ROUND" || code === "AI_NOT_CONFIGURED") return `error.${code}`;
  void status;
  return "error.GROUPING_FAILED";
}

/**
 * Join the server's ids back to the texts the host's screen already holds. `count` is the server's
 * number of answers in the group; `texts` is only the ones this screen can show (a round that
 * withholds its content from the broadcast has none), so the count never depends on the join.
 */
export function groupRows(
  groups: ResponseGroupView[],
  entries: Array<{ id: string; text: string }>,
): Array<{ label: string; count: number; texts: string[] }> {
  const byId = new Map(entries.map((e) => [e.id, e.text]));
  return groups
    .filter((g) => g.entryIds.length > 0)
    .map((g) => ({
      label: g.label,
      count: g.entryIds.length,
      texts: g.entryIds.flatMap((id) => (byId.has(id) ? [byId.get(id)!] : [])),
    }));
}
